import Navbar from "./navbar"
import { Outlet } from "react-router"
import Footer from './footer'
import Loading from "./loading"
import React from 'react'

const Layout = () => {
    const [loading, setLoading] = React.useState<boolean>(false)

    return (
        <div className="relative">
            {loading &&
                <Loading />
            }
            <Navbar />
            <Outlet context={[loading,setLoading]} />
            <Footer />
        </div>
    )
}

export default Layout